import TortasMaster from './Master';
export default class CompraPie extends TortasMaster {
    state = { title: '', values: [] };
    estados = ['CANCELADO', 'SIN FACTURA', 'FACTURADA'];
    api = 'Compra';
    title='COMPRAS'
}

